import axios from 'axios';

export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig();
    const baseURL = import.meta.server ? config.public.serverApiBaseURL || '' : config.public.clientApiBaseURL || '';
    const instance = axios.create({
        baseURL: baseURL || '',
    });

    console.info('Axios instance created', baseURL);

    instance.interceptors.response.use(
        (response) => {
            if (response.headers['x-wp-totalpages']) {
                return {
                    list: response.data,
                    pagination: {
                        total: +response.headers['x-wp-total'] || null,
                        totalPages: +response.headers['x-wp-totalpages'] || null,
                    },
                };
            }
            return response.data;
        },
        (error) => Promise.reject(error)
    );

    return {
        provide: {
            axios: instance,
        },
    };
});
